import React from 'react'

import TabsSelectorUI5 from "../../gd-components/tabs-selector/tabs-selector-ui5"

type Props = {
    allocationMode  : string,
    disabled?       : boolean,
    onSelect        : any
}

export default function TimeAllocation(props:Props) {

    // allocation
    const getDistributeOption = (id:any) => ({
        value   : id,
        icon    : gd.const.timeline.timeAllocation.distributionModeIcon[id],
        label   : gd.const.timeline.timeAllocation.distributionModeLabel[id]
    })

    const distributeOptions:any[] = [];
    _.mapKeys(gd.const.timeline.timeAllocation.distributionMode, mode=>{distributeOptions.push(getDistributeOption(mode))})

    return (
        <TabsSelectorUI5 options    = {distributeOptions}
                         selectedId = {props.allocationMode}
                         disabled   = {props.disabled}
                         onChange   = {props.onSelect}/>
    )
}